import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa";
import ReactPaginate from 'react-paginate';
import UserServices from '../services/UserServices';

function SallerViewActivity() {

  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.userId;

  const [activities, setActivities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {

    if (!userId) return;

    const payload = { userId };

    setIsLoading(true);

    UserServices.getUserActivity(payload)
      .then((res) => {

        //  console.log('ajay', res.status);

        if (res.status === true) {
          setActivities(res.data || []);
        }

      })
      .catch((err) => {
        console.log("API ERROR:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });

  }, [userId]);


  const formatDate = (dateString) => {

    if (!dateString) return "N/A";

    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };


  const filteredActivities = activities.filter((activity) => {

    const type = activity?.activityType?.toLowerCase() || '';
    const description = activity?.description?.toLowerCase() || '';
    const ip = String(activity?.ipAddress || '');

    return (
      type.includes(searchQuery.toLowerCase().trim()) ||
      description.includes(searchQuery.toLowerCase().trim()) ||
      ip.includes(searchQuery)
    );

  });


  const usersPerPage = 20;

  const indexOfLast = currentPage * usersPerPage;
  const indexOfFirst = indexOfLast - usersPerPage;

  const currentActivities = filteredActivities.slice(indexOfFirst, indexOfLast);


  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };


  const handleBack = () => {
    navigate(-1);
  };


  return (

    <div className="right_col" role="main">

      <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">

        <div className="my-auto">

          <h5 className="page-title fs-21 mb-1">Saller View Activity</h5>

          <nav>
            <ol className="breadcrumb mb-0">

              <li className="breadcrumb-item">
                <NavLink to="/">Home</NavLink>
              </li>

              <li className="breadcrumb-item active">
                <NavLink to="/sallers">Saller List</NavLink>
              </li>

            </ol>
          </nav>

        </div>

        <button
          onClick={handleBack}
          className="btn btn-sm btn-outline-secondary d-flex align-items-center"
        >
          <FaArrowLeft className="me-1" /> Back
        </button>

      </div>


      <div className="container-box px-0 user-manager">

        <div className="Tablesearch_design">
          <div className='row'>
            <div className='col-md-6'>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <div className=' w-100'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search by Ip Address, Activity Type, Description"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className='form-control'
                  />
                </div>
                <div>
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>
           
          </div>


        </div>

        <div className="container-box-inner table-reponsive-tabe">

          <table className="table table-striped">

            <thead>
              <tr>
                <th>#</th>
                <th>USER ID</th>
                <th>ACTIVITY TYPE</th>
                <th>DESCRIPTION</th>
                <th>IP ADDRESS</th>
                <th>DEVICE</th>
                <th>DATE</th>
              </tr>
            </thead>

            <tbody>

              {isLoading && (
                <tr>
                  <td colSpan="7">Loading...</td>
                </tr>
              )}

              {currentActivities.length === 0 && !isLoading && (
                <tr>
                  <td colSpan="7">No Activity Found</td>
                </tr>
              )}

              {currentActivities.map((activity, index) => (

                <tr key={activity?._id || index}>

                  <td>{index + 1 + indexOfFirst}</td>

                  <td>{activity?.userId}</td>

                  <td>{activity?.activityType}</td>

                  <td>{activity?.description}</td>

                  <td>{activity?.ipAddress}</td>

                  <td>{activity?.deviceName || activity?.deviceType || "N/A"}</td>

                  <td>{formatDate(activity?.createdAt)}</td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>


        {/* PAGINATION */}

        <div className="pagination">

          <ReactPaginate

            pageCount={Math.ceil(filteredActivities.length / usersPerPage)}

            pageRangeDisplayed={3}

            marginPagesDisplayed={1}

            onPageChange={handlePageClick}

            containerClassName={'pagination'}

            activeClassName={'active'}

            previousLabel={'Previous'}

            nextLabel={'Next'}

            breakLabel={'...'}

            pageClassName={'page-item'}

            pageLinkClassName={'page-link'}

            previousClassName={'page-item'}

            previousLinkClassName={'page-link'}

            nextClassName={'page-item'}

            nextLinkClassName={'page-link'}

          />

        </div>

      </div>

    </div>

  );

}

export default SallerViewActivity;